import React from 'react';
import './App.css';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import ListGroup from 'react-bootstrap/ListGroup';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';

import GetIssues from './GetIssues';
import LastUpdated from './LastUpdated';
import ListIssues from './ListIssues';
import Paginator from './Paginator';
import SiteDescription from './SiteDescription';


function App() {
  return (
    <Container>
      <Navbar>
        <Navbar.Brand>
          Python Issues for Beginners
        </Navbar.Brand>
      </Navbar>
      <SiteDescription />
      <GetIssues wrappedRender={ (responseData, getPage) =>
        responseData ? (
          <React.Fragment>
            <ListIssues issues={ responseData.issues } />
            <Paginator currentPage={ responseData.page_num }
                       numPages={ responseData.num_pages }
                       loadPage={ getPage }/>
            <Row className={"mb-2"}>
              <Col>
                <LastUpdated lastUpdated={ responseData.updated_at } />
              </Col>
            </Row>
          </React.Fragment>
        ) : (
          <Row>
            <Col>
              <ListGroup>
                <ListGroup.Item>
                  Loading data...
                </ListGroup.Item>
              </ListGroup>
            </Col>
          </Row>
        )}
      />
    </Container>
  );
}

export default App;
